// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
/// <summary>
/// Панель для вертикальных таблиц
/// </summary>

import { Resources } from "../../../Commons/properties/Resources.js";
import { Color, SolidBrush } from "../../../Commons/Graphics.js";
import { QuickTableEditingInfo } from "../../elements/QuickTable/QuickTableMisc.js";
import { ApplicationPanelNew } from "../../panels/ApplicationPanelNew.js";
import { DynProperty } from "../../../Commons/DynProperty.js";
import { SessionSettings } from "../../../Commons/SessionSettings.js";

export let VerticalApplicationPanelNew = ApplicationPanelNew.extend(
    {
        data: function ()
        {
        },
        VerticalPanelDataProvider: null,
        sett: null,
    });

//#region Properties

/// <summary>
/// 
/// </summary>
/*public virtual Dictionary<string, RowPropertyClass>*/

Object.defineProperty(VerticalApplicationPanelNew.prototype, 'WrapperRows',
    {
        get: function ()
        {
            let tempList = new Object();//new Dictionary<string, RowPropertyClass>();
            for (let i = 0; i < this.VerticalPanelDataProvider.items.length; i++)
            {
                if (Resources.IsHidden(this.VerticalPanelDataProvider.items[i].LocalizationKey) || this.VerticalPanelDataProvider.items[i].Hidden)
                    continue;
                let wrapper = this.VerticalPanelDataProvider.items[i];
                tempList[wrapper.Id] = wrapper;
            }
            return tempList;
        },
        set: function ()
        {
            if (value === null || value.length === 0)
                return;
            for (let i = 0; i < this.VerticalPanelDataProvider.items.length; i++)
            {
                let dataItem = this.VerticalPanelDataProvider.items[i];
                let wr = value[dataItem.Id];
                if (wr)
                    VerticalApplicationPanelNew.Copy(wr, dataItem);

            }
            // 
            this.PopulateTable();
        }
    });

VerticalApplicationPanelNew.Copy = function (wr, dataItem)
{
    dataItem.visible = wr.visible;
    dataItem.SortIndex = wr.SortIndex;
    dataItem.callBack(wr.Properties);
}

//#endregion

VerticalApplicationPanelNew.prototype.oncomplete = function ()
{
    this.sett = SessionSettings;
    ApplicationPanelNew.prototype.oncomplete.apply(this);
    this.InitializeDataProvider();
}

/// <summary>
/// Constructors
/// </summary>       
//public VerticalApplicationPanelNew(BaseApplication baseApplication, SessionSettings sett)
//                : base(baseApplication)
//{
//    this.sett = sett;
//    propertiesForTemplate.Add("dataItems");
//}

//#region ApplicationPanelNew overrided

VerticalApplicationPanelNew.prototype.localize = function ()
{
    ApplicationPanelNew.prototype.localize.call(this)
    this.PopulateTable()
}

// TODO. Optimize.
VerticalApplicationPanelNew.prototype.TickAsync = function ()
{
    if (!this.get("visible"))
        return;
    // Update data
    if (this.VerticalPanelDataProvider)
        this.VerticalPanelDataProvider.UpdateItems()

    ApplicationPanelNew.prototype.TickAsync.call(this)
}

VerticalApplicationPanelNew.prototype.Properties = function ()
{
    let prop = ApplicationPanelNew.prototype.Properties.call(this);
    //prop.push(new DynProperty("dataItems", Serializator.Serialize(VerticalPanelDataProvider.items), DynProperty.STRING, DynProperty.HIDDEN_GROUP));
    return prop;
}

/// <summary>
/// 
/// </summary>        
VerticalApplicationPanelNew.prototype.callBack = function (properties)
{
    ApplicationPanelNew.prototype.callBack.call(this, properties);

    //let prop = DynProperty.getPropertyByName(properties, "dataItems");
    //if (prop != null)
    //    VerticalApplicationPanelNew .CopyDataItems((List<VerticalPanelDataProviderItem>)Serializator.Deserialize(prop.Value.ToString()), VerticalPanelDataProvider.items);

    this.PopulateTable();
}

VerticalApplicationPanelNew.prototype.dispose = function ()
{
    if (this.VerticalPanelDataProvider)
        this.VerticalPanelDataProvider.Source = null // вызов DisposeHandler

    ApplicationPanelNew.prototype.dispose.call(this)
}

//#endregion

//#region VerticalApplicationPanelNew functions

/// <summary>
/// Создание провайдера - описание все возможных итемов и групп
/// </summary>
VerticalApplicationPanelNew.prototype.InitializeDataProvider = function ()
{

}

/// <summary>
/// Заполнение таблицы
/// </summary>
VerticalApplicationPanelNew.prototype.PopulateTable = function ()
{
    if (this.quickTableRactive === null || this.quickTableRactive.quickTable === null || this.VerticalPanelDataProvider === null)
        return;

    // Create new rows
    this.VerticalPanelDataProvider.GenerateItems(this.VerticalPanelDataProvider, this.sett);

    // Fill table
    let quickTable = this.quickTableRactive.quickTable;
    //quickTable.SaveGroupsState();

    //quickTable.SuspendDrawing = true;
    quickTable.ClearAll();

    for (let i = 0; i < this.VerticalPanelDataProvider.generatedTableItems.length; i++)
    {
        let item = this.VerticalPanelDataProvider.generatedTableItems[i];
        let row = quickTable.AddItem(item);
        row.cells[0].BackColorBrush = item.CellsColor[0] === Color.Empty ? null : new SolidBrush(item.CellsColor[0]);
        row.cells[0].ForeColorBrush = item.CellsForeColor[0] === Color.Empty ? null : new SolidBrush(item.CellsForeColor[0]);
        row.cells[1].BackColorBrush = item.CellsColor[1] === Color.Empty ? null : new SolidBrush(item.CellsColor[1]);
        row.cells[1].ForeColorBrush = item.CellsForeColor[1] === Color.Empty ? null : new SolidBrush(item.CellsForeColor[1]);

        //
        if (!item.ToolTipKey)
            row.cells[1].ToolTip = row.cells[0].ToolTip = Resources.getResource(item.ToolTipKey, this.sett.Locale);

        // если не стринг то надо создать экшн-ячейку
        if (item.DynPropertyControltype != DynProperty.STRING)
            this.SetEditingInfo(row, item.DynPropertyControltype);
    }

    quickTable.setGroupByColumnIdx(
        this.VerticalPanelDataProvider.hideGroupHeaders ? -1 : 2)
}

VerticalApplicationPanelNew.prototype.SetEditingInfo = function (row, controlType)
{
    row.cells[1].ReadOnly = false;
    row.cells[1].QuickTableEditingInfo = new QuickTableEditingInfo(controlType);
    // при необходимости дополнить.
}

//#endregion

//#region Misc

/// <summary>
/// 
/// </summary>        
VerticalApplicationPanelNew.CopyDataItems = function (from, targets)
{
    let fromHash = new Object();//new Dictionary<string, VerticalPanelDataProviderItem>();
    for (let i = 0; i < from.length; i++)
        fromHash[from[i].Id] = from[i];

    for (let i = 0; i < targets.length; i++)
    {
        let sourceItem = fromHash(targets[i].Id);
        if (sourceItem)
            targets[i].Apply(sourceItem);
    }
}

//#endregion
